import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared/shared.module';
import { GenericPageComponent } from './generic-page.component';
import { Http, HttpModule } from '@angular/http';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    HttpModule
  ],
  declarations: [
    GenericPageComponent,
  ],
  exports: [
    GenericPageComponent,
  ],
})
export class GenericPageModule {
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/generic-page/generic-page.module.ts